import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isTabloMemberPickCompleted',
    standalone: false
})
export class IsTabloMemberPickCompletedPipe implements PipeTransform {
  transform(
    value: unknown,
    config: Record<
      string,
      { x: number; y: number; photoId: string; groupId: string }
    >,
  ): boolean {
    if (typeof value !== 'string') {
      return false;
    }
    const memberConfig = config[value];
    if (!memberConfig) {
      return false;
    }
    return !!memberConfig.photoId && !!memberConfig.groupId;
  }
}
